import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiRequest from "../../api/request";

const initialState = {
  assessmentData: {},
  coursewiseData: [],
  gradeLeadData: [],
  loading: false,
};
// ----------------------------------categorycrud-----------------------------------
export const getAssessmentData = createAsyncThunk(
  "assessment/allassessments",
  async ({ fromDate, toDate, userID, dateFilter }) => {
    const res = await apiRequest({
      method: "get",
      url: `assesment-tool-dashboard?fromDate=${fromDate}&toDate=${toDate}&userID=${userID}&dateFilter=${dateFilter}`,
    });
    console.log("Get assessments", res);
    return res;
  }
);

export const getCourseWiseDetails = createAsyncThunk(
  "assessment/coursewise",
  async ({ fromDate, toDate, userID, dateFilter, course_name }) => {
    const res = await apiRequest({
      method: "get",
      url: `assesment-tool-dashboard/get-course-mark-details?course_name=${course_name}&userID=${userID}&fromDate=${fromDate}&toDate=${toDate}&dateFilter=${dateFilter}`,
    });
    console.log("Get course wise", res);
    return res;
  }
);

export const getGradeWiseDetails = createAsyncThunk(
  "assessment/gridewise",
  async ({
    fromDate,
    toDate,
    matrix_name,
    grade_name,
    userID,
    dateFilter,
    course_name,
    page,
    limit,
    search,
  }) => {
    const res = await apiRequest({
      method: "get",
      url: `assesment-tool-dashboard/get-matrix-leads?${
        course_name ? `course_name=${course_name}` : ""
      }&userID=${userID}${matrix_name ? `&matrix_name=${matrix_name}` : ""}${
        grade_name ? `&grade_name=${grade_name}` : ""
      }${fromDate ? `&fromDate=${fromDate}` : ""}${
        toDate ? `&toDate=${toDate}` : ""
      }${
        dateFilter ? `&dateFilter=${dateFilter}` : ""
      }&page=${page}&limit=${limit}${search ? `&search=${search}` : ""}`,
    });
    console.log("Get course wise", res);
    return res;
  }
);

const assessmentDashboardSlice = createSlice({
  name: "assessment",
  initialState,

  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAssessmentData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAssessmentData.fulfilled, (state, action) => {
      state.loading = false;
      state.assessmentData = action.payload.data;
    });
    builder.addCase(getCourseWiseDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCourseWiseDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.coursewiseData = action.payload;
    });
    builder.addCase(getGradeWiseDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getGradeWiseDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.gradeLeadData = action.payload;
    });
  },
});

// export const { apiCallData } = permissionSlice.actions;

export default assessmentDashboardSlice.reducer;
